import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { createSilo } from '../../services/Silo/siloService';
import ErrorModal from '../Modals/ErrorModal';
import SuccessModal from '../Modals/SuccessModal';
import InputField from '../Utils/InputField';
import WeightInput from '../Utils/WeightInput';
import HarvestInput from '../Utils/HarvestInput';

const CreateSiloModal = ({ show, handleClose, refreshSilos, onCreated }) => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  
  const { register, handleSubmit, formState: { errors }, reset, control, setValue } = useForm({
    defaultValues: {
      capacity: 0,
      stock: 0,
    },
  });
  
  const onSubmit = async (data) => {
    try {
      const siloData = {
        ...data,
        harvestId: data.harvestId?.id,
      };
      const created = await createSilo(siloData);

      if (onCreated) {
        onCreated({
          id: created.uuid,
          name: created.name,
        });
      } else {
        setSuccessMessage('Silo criado com sucesso!');
        setShowSuccessModal(true);
        setValue('personId', { name: '', id: null });
      }
    
      reset();
    } catch (error) {
      setErrorMessage(error.message || 'Erro ao criar Silo.');
      setShowErrorModal(true);
    }
  };

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    refreshSilos();
    handleClose();
  };

  useEffect(() => {
    if (show) {
      reset();
    }
  }, [show, reset]);

  useEffect(() => {
    setValue('capacity', 0);
    setValue('stock', 0);
  }, [setValue]);

  return (
    <>
      <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={false} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Silo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.stopPropagation();
              handleSubmit(onSubmit)(e);
            }}
          >
            <Row>
              <Col md={8}>
                <InputField
                  label="Nome"
                  name="name"
                  placeholder="Digita o nome"
                  register={register}
                  errors={errors}
                  rules={{ required: 'Nome é obrigatório' }}
                />
              </Col>
              <Col md={4}>
                <Controller
                  name="capacity"
                  control={control}
                  rules={{ required: 'Capacidade é obrigatório' }}
                  render={({ field, fieldState }) => (
                    <WeightInput
                      value={field.value}
                      onChange={field.onChange}
                      label="Capacidade"
                      isInvalid={!!fieldState.error}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Controller
                  name="harvestId"
                  control={control}
                  render={({ field, fieldState }) => (
                    <HarvestInput
                      value={field.value}
                      onChange={(selectedHarvest) => setValue('harvestId', selectedHarvest)}
                      label="Safra"
                      isInvalid={!!fieldState.error}
                      createdNew={true}
                    />
                  )}
                />
              </Col>
            </Row>
            <Button variant="primary" className="button-custom w-100 mt-3" type="submit">
              Cadastrar
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <ErrorModal
        show={showErrorModal}
        handleClose={handleCloseErrorModal}
        errorMessage={errorMessage}
      />

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        successMessage={successMessage}
      />
    </>
  );
};

export default CreateSiloModal;